<div class="ax-panel">
  <app-grid name="Global Factor Performance Attribution Factor Name"
            (cellButtonClicked)="cellButtonClickHandler($event)"
            (onCellDrag)="cellDragHandler($event)">
  </app-grid>
</div>
